<template>
    <div class="cases-page">
        <div class="page-header-block">
            <img :src="pageBg" v-if="channelWidth > 768"/>
            <img :src="phoneBg" v-else/>
        </div>
        <div class="page-content">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="body-tab-title">
                    {{'成功案例  >  '+ pageInfoList[pageIndex].title +'  >  '+pageInfoList[pageIndex].list[listIndex].title}}
                </div>
                <div class="body-info">
                    <div class="info-title">项目背景</div>
                    <div class="info-content">
                        <img :src="pageInfoList[pageIndex].list[listIndex].icon"/>
                        <div>
                            <div class="info-text" v-for="item in pageInfoList[pageIndex].list[listIndex].list1">
                                {{item}}<br/>
                            </div>
                        </div>

                    </div>
                    <div class="info-title">项目界面</div>
                    <div class="show-image" :class="[pageInfoList[pageIndex].list[listIndex].image.length==1?'img-center':'']">
                        <img :src="item" v-for="item in pageInfoList[pageIndex].list[listIndex].image"/>
                    </div>
                    <div class="info-title">解决方案</div>
                    <div class="info-text" v-for="item in pageInfoList[pageIndex].list[listIndex].list2">
                       {{item}}<br/>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import PageBg from '../../image/common/cases_page_header.png'
    import PhoneBg from '../../image/common/cases_phone_header.png'
    import PageInfo from '../../image/page_info.png'
    import PageShow from '../../image/common/page_show.png'
    import ClassIcon from '../../image/products/class_icon.png'
    import HbIcon from '../../image/products/hb_icon.png'
    import HgIcon from '../../image/products/hg_icon.png'
    import NyIcon from '../../image/products/ny_icon.png'
    import CgIcon from '../../image/products/cg_icon.png'
    import NyImg1 from '../../image/products/ny_page_img1.png'
    import NyImg2 from '../../image/products/ny_page_img2.png'
    import YzImg1 from '../../image/products/yz_img1.png'
    import YzImg2 from '../../image/products/yz_img2.png'
    import TmImg1 from '../../image/products/tm_img1.png'
    import TmImg2 from '../../image/products/tm_img2.png'
    import GgImg1 from '../../image/products/gg_img1.png'
    import GgImg2 from '../../image/products/gg_img2.png'
    import XxImg1 from '../../image/products/xx_img1.png'
    import XxImg2 from '../../image/products/xx_img2.png'
    import EPowerImg1 from '../../image/products/e_power1.png'
    import EPowerImg2 from '../../image/products/e_power2.png'
    import ManagerIcon from '../../image/products/manager_icon.jpeg'
    import ManagerImg1 from '../../image/products/manager_img1.png'
    import ManagerImg2 from '../../image/products/manager_img2.png'
    import unitIcon from '../../image/products/unit_logo.png'
    import edm1 from '../../image/products/edm_img1.png'
    import edm2 from '../../image/products/edm_img2.png'
    import edm3 from '../../image/products/edm_img3.png'
    import qhnc1 from '../../image/products/qhnc_img1.png'
    import qhnc2 from '../../image/products/qhnc_img2.png'
    import qhnc3 from '../../image/products/qhnc_img3.png'
    import jyqh1 from '../../image/products/jyqh_img1.png'
    import jyqh2 from '../../image/products/jyqh_img2.png'
    import dl3Img1 from '../../image/products/dl3_1.png'
    import dl3Img2 from '../../image/products/dl3_2.png'
    import dl3Icon from '../../image/products/dl3_icon.png'
    import jyqh3 from '../../image/products/jyqh_img1.png'

    export default {
        name: "cases-page",
        data(){
          return{
              channelWidth: null,      //浏览器窗口宽度
              pageBg:PageBg,
              pageInfo:PageInfo,
              phoneBg:PhoneBg,
              pageShow:PageShow,
              pageKey:null,
              pageIndex:null,
              listIndex:0,
              pageInfoList:[
                  {title:'电力',list:[
                          {
                              title:'无锡镇江电力物联网系统',
                              id:'first',
                              image:[EPowerImg1,EPowerImg2],
                              icon:unitIcon,
                              list1:[
                                  '建设泛在电力物联网的过程，就是推动电网向能源互联网转型升级、持续深化能源革命的过程。大力发展清洁能源，加快构建清洁低碳、安全高效的能源体系，对加快推动电网转型升级提出前所未有的要求。随着能源清洁低碳转型的深入推进，各种新型用能形式不断涌现。必须通过融合发展泛在电力物联网，推动传统电网向能源互联网升级。以数字技术为传统电网赋能，不断提升电网的感知能力、互动水平、运行效率，有力支撑各种能源接入和综合利用，持续提高能源效率，实现了由“用好电”向“用好能”的转变。',
                                  '建设泛在电力物联网的过程，就是构建合作共赢产业生态、促进产业链水平提升的过程。电网连接电力生产和消费，在能源电力产业中具有链条长、资源聚集、带动力强的显著特点。\n',

                              ],
                              list2:[
                                  '1、全面感知:对电力生产、输送、消费、管理各环节信息的全面智能识别，在信息采集、汇聚处理基础上实现全过程、资产全寿命、客户全方位感知;\n',
                                  '2、IP互联:传感器之间、传感器与应用系统之间通过电力物联网标准化通信协议与通信网络，实现信息有效传递与交互;\n',
                                  '3、可靠传输:利用电力光纤、载波、无线专网、互联网等，实现感知层和应用层之间的可靠信息传递;\n',
                                  '4、智能处理:综合运用高性能计算、人工智能、分布式数据库等技术，进行数据存储、数据挖掘、智能分析，支撑应用服务、信息呈现、客户交互等业务功能;\n',
                                  '5、IT融合:成为企业IT架构的延伸，完善补充企业IT架构，同时作为企业IT架构最重要的组成部分之一，与企业IT架构高度融合。\n'
                              ]
                          },
                          {
                              title:'江阴青禾绿色微电网项目',
                              id:'second',
                              image:[jyqh1,jyqh2],
                              icon:unitIcon,
                              list1:[
                                  '江阴青禾绿色微电网项目是一个以风、光、储、荷一体化应用为主题的泛在电力物联网示范项目，坐落在徐霞客镇阳庄村青禾农场，占地约500亩。项目建设包括156kWp的屋顶分布式光伏发电系统、5kW的杆式水平轴风力发电系统、2kW的卧式水平轴风力发电系统、360kW冷热供应能力的地源热泵系统、200kWh的磷酸铁锂移动储能系统、100kW的三端口能量路由器（两个交流端口一个直流端口）、1座4000平米的智能大棚、2*50kW直流充电桩系统，6*7kW交流充电桩系统、各类负荷、环境传感器、LoRa网络、智能用电系统和智慧农场系统等。\n',
                                  '项目分两期进行了建设，18年《江阴锡能-绿色复合型微电网系统系统集成合同》项目由江阴公司三产锡能实业出资170.96万，19年《国网无锡江阴市供电公司乡村电气化建设示范项目》投入150万。\n'
                                 ],
                              list2:[
                                  '建立深度感知泛在物联的试点示范。青禾农场—泛在物联微电网通过配置LoRa网络，实现对农场范围内的信息高速通道全覆盖。通过配置智能用电采集终端，实现对用户负荷的精细化采集和管理，利用获取的负荷数据，开展能效诊断，分析挖掘节能潜力，制定节能用电策略，降低能源成本。通过农场内布设各种生产环境传感节点，实现农业生产环境的智能感知、智能预警、智能分析，为农业生产提供精准化种植、可视化管理、智能化决策，提高生产效率和产出。\n',
                                  '探索综合能源有效应用的典型场景。研究包含分布式发电、储能、交直流混合供电、能量路由、智能用电等元素，涵盖冷、热、电、储具有推广价值的综合能源服务典型工程解决方案。建立综合能源服务工程的成本收益模型，通过代入不同的用户及相应的费用政策，研究最优收益模式，并在目标指引下制定典型综合能源服务工程能量管理策略与协调控制方法。\n',
                                  '打造绿色低碳和谐共生的现代农场。通过应用风能、光伏、储能、地源热泵等多种绿色可再生能源，布设充电桩、电气化生产装置实现农场内运输流通、生产办公的电气化，最大程度的减少传统化石能源造成的碳排放及二氧化硫、氮氧化合物等多种有害物质的排放，减少相应的排灰废水等对水环境的污染，实现环境融合共生。（经过测算，可再生能源已经能够完全满足正常的农场生产、生活所需）\n',
                              ]
                          },{
                              title:'建德变电站智慧平台',
                              id:'third',
                              image:[dl3Img1,dl3Img2],
                              icon:dl3Icon,
                              list1:[
                                  '国家电网颁布的《智能变电站技术导则》定义智能变电站是通过运用先进可靠、环保节能并且高集成度的智能化设备将整个变电站系统做成一个网络化、数字化、标准化的信息平台，从而实现变电站的信息处理的高效与可靠，并且完成信息收集、控制与保护等功能的自动化。\n',
                                  '通过智能技术的运用，使变电站单体与临近变电站、控制调度中心等部门实现自动控制、协同动作以及在线辅助分析等行为。通过智能变电站可以在很大程度上提高电网的稳定性与高效安全，对于我国的经济发展起到了非常重要的基础支撑作用。据统计，目前我国的智能变电站系统通过采用先进的自动化数据采集与反馈系统，能够为变电站的自动化程度提高提供支撑。\n',
                                  '在新型变电站中，主要采用的是集中配屏、全部分散以及局部分散等几种模式，基于人工智能的图像分析识别技术在变电站二次设备智能巡检系统中的研究与应用主要研究针对二次屏柜进行智能监控，具体为以下3个方面：首先，所有的视频均通过以太网传输至智能算法在线分析服务器进行识别、分析及上传数据。其识别对象涵盖大部分二次屏柜内部对象。其次，开发数据管理及展示平台，将汇集的信息数据及监控画面显示至监控屏幕，供工作人员进行异常状态的监测、往期数据查询和报表查看等。最后，开发相应的APP，便于工作人员随时查验现场情况。未来变电站的全自动化是发展趋势，因此需要不断提高电气设备与计算机技术作为支撑。\n'
                              ],
                              list2:[
                                  '1、互联网信息化伴随着现代计算机技术与通信技术的飞速发展，现在智能变电站的开放式分层设计越来越普遍，可以在整个系统形成“三层两网”结构，实现整个变电站数据接收与发送的信息化、智能化与数字化。数据互联是现代自动化系统的基础要求，在智能变电站的运行中保证各设备层次间数据的交换与互联，保证变电站网络系统与上级调度站间的数据交换的稳定性与实时性，是保证智能变电站安全运行的重要基础。\n',
                                  '2、系统集成化现代科技发展使智能变电站系统迎来了飞速发展的机遇，现在智能变电站系统越来越集成化，集成化的电网系统是现代化电网的一个重要特点。集成化系统包含了传统五防系统的全部功能，并且伴随着系统集成度的提高，系统配置更加灵活，既可以单独配置，也可以与其他装置集成使用。作为智能变电站监控系统的升级功能，集成五防系统相较于传统的五防系统更加稳定可靠。\n',
                                  '3、智能技术在变电站中的应用智能技术在变电站中的应用能够促使变电站高压配电设备具备智能化，实现小范围内的智能电网建设，通过运用智能传感器的实时监控功能，可以很好地监控设备运行状态，并根据实际的监控结果进行控制与调整。对于高压设备的断路器实现一体化设计，从而实现一体化管理的目的。智能技术在变电站中大量应用，能够极大程度地控制无效数据的采集量，并提升变电站的整体监控效率。\n',
                              ]
                          }
                      ]},
                  {title:'园区',list:[
                          {
                              title:'化工园区二道门智能化管理系统',
                              id:'first',
                              image:[ManagerImg1,ManagerImg2],
                              icon:ManagerIcon,
                              list1:[
                                  '化学工业在各国的国民经济中占有重要地位,是许多国家的基础产业和支柱产业。化学工业的发展速度和规模对社会经济的发展有着直接影响，对人类经济、社会发展具有重要的现实意义，世界化工产品年产值已超过15000亿美元。近年来,时有化工企业意外事故发生,给人员及财产带来巨大损失，已经引起了政府及相关部]的重视，多次强调批示加大化工企业的安全管理力度,并将“二 道门”建设工作纳入年度安全生产目标考核的内容，全面提升企业风险管控能力和精细化安全管理水平。\n'
                              ],
                              list2:[
                                  '1.化工企业二道门智能化管理系统通过智能控制和人工结合的方式，在化工企业厂区范围内将生产区域与办公、生活区域有效隔离，对于出入生产区域人员和车辆通过设置门]禁的方式进行有效管控(非防爆区域)，杜绝未经培训、未经批准人员进入生产区域，并实现对本企业职工、外来作业人员、其他人员及货运车辆进行分类统计，实时将数据通过LED屏进行发布，精确显示生产区域内在线人员动态,以及厂区货运车辆数量，确保安全生产,杜绝危险事故发生。\n',
                                  '2.该系统主要针对化工企业的两类通道进行重点管控:厂区物流口和生产区与办公、生活区域之间的二道门。\n',
                                  '3.物流口的管控对象主要是出入厂区的货车,包括货车司机和随车人员。通过车牌识别的方式记录进出厂区的货车信息，统计厂区内货车数量;司机及随车人员在门卫处通过刷身份证的方式将身份信息录入系统，同时在系统内将车辆和司机及随行人员进行绑定，并统计生产区内人员数量。实现化工企业对物流门安全有效的管理。\n',
                                  '4.生产区与办公、生活区域之间的二道门管控主要是针对进出生产区域的各类人员。通过设置门 ]禁的方式杜绝“三无"人员随意进入生产区域。针对一些重点生产危险区域(如罐区)，通过设置低频远距离识别设备，实现对人员进出方向的判断和人员计数的功能，精确统计危险生产区域内人员动态，第一时间掌握企业应急状态时涉险人员情况，提高应急救援效率。\n',
                              ]
                          },
                          {
                              title:'化工园区二道门人员定位解决方案',
                              id:'second',
                              image:[edm1,edm2],
                              icon:unitIcon,
                              list1:[
                                  '企业的快速发展也伴随着一些问题，一方面由于厂区面积大、人员分布分散、管理难度逐渐增加。员工上班期间的状况无法判断，可能出现窜岗、偷懒等情况，绩效考核缺乏数据支持。客户主要对生产车间和罐区需要严格管理,需要高精度人员定位;同时对于外来访客人员的管理也非常重视，需要知道访客是否进入防爆区等重点区域。\n',
                                  '基于客户极高的管理需求，我公司利用在物联网、位置定位服务、通讯、地图等多领域的技术优势，在企业IT 智能化解决方案中提出了“基于定位的智能安全管理系统”，来满足人员以及车辆的管理需求。本系统结合了触发式精准定位技术、物联网传输技术、大数据技术，以及云计算等技术。\n'
                              ],
                              list2:['1、精准定位  化工园区环境复杂，室内室外交替，如何通过技术手段精准定位人员位置\n',
                                  '2、聚集统计  人员聚集容易造成群体伤害，如何控制人员聚集情况，减少突发事件的集中伤害\n',
                                  '3、一键求救  园区范围广，覆盖面积比较大，地形复杂，如何保证员工在遇到危险能够及时准 确发出求救信息\n',
                                  '4、紧急救援  遇到突发事件，救援要做到全面，不能留一人在园区危险中，需要统计人员疏散情况\n',
                                  '5、资产管理  园区大型设施，包括固定设施的位置，移动设施的轨迹，都需要进行统一呈现和管理。\n']
                          },{
                              title:'安环眼·智能巡检',
                              id:'third',
                              image:[edm1,edm2],
                              icon:unitIcon,
                              list1:[
                                  '传统的人工巡检采用的是携带纸质的标准巡视作业书，由巡检人员手工填写巡检结果。巡检结束后，将巡检记录册汇总到电网中心备案，并根据故障记录采取必要的维修措施。传统的作业书、签到本工作方式，不利于对巡检员工作进行监督，从而无法保证少检、漏检情况的发生。且不利于企业现代化科学管理。变电站的智能巡检系统的设计旨在实现包括人员管理、设备巡检、规范化缺陷描述、记录数据管理、检索、报表生成等全部工作的自动化、信息化、数字化管理。先进性在于淘汰纸张，提高工作效率和质量，降低运营成本, 缩短故障处理的时间，避免事故的发生。有效地监督巡检员的工作。通过记录巡检时间，保证巡检员的工作“准时到位”。\n'
                              ],
                              list2:['1、利用蓝牙信标固定巡检点位，通过判断智能巡检机接收到的蓝牙信标位置判断巡检点位覆盖率和巡检完成度。\n',
                                  '2、通过分析智能巡检终端上报的数据，清晰查看巡检员巡检的完成度、任务进行情况和当前所在位置信息。\n',
                                  '3、通过PC端对一段时间的上报数据进行分析和汇总得出各组巡检情况统计表，并用图表直观展示出来。\n',
                                  '4、利用智能巡检终端，将手机与对讲机功能相结合，减少巡检员携带机器数量，简化工作流程。\n']

                          }
                      ]},
                  {title:'农业',list:[
                          {
                              title:'睢宁智慧农业物联网',
                              id:'first',
                              image:[NyImg1,NyImg2],
                              icon:NyIcon,
                              list1:[
                                  '用现代信息技术改造传统农业、装备农业是实现农业现代化的重要途径。物联网技术是现代信息技术的新生力量，是推动信息化与农业现代化融合的重要切入点，也是推动我国农业向“高产、优质、高效、生态、安全”发展的重要驱动力。农业物联网技术集成先进传感器、无线通讯和网络、辅助决策支持与自动控制等高新技术，可以实现对农业资源环境、动植物生长等的实时监测，获取动植物生长发育状态、病虫害、水肥状况以及相应生态环境的实时信息，并通过对农业生产过程的动态模拟和对生长环境因子的科学调控，达到合理使用农业资源、降低成本、改善环境、提高农产品产量和质量的目的。\n',
                                  '近年来，在政府、科研机构及农业生产企业等的共同推动下，部分地区在农业物联网技术应用方面进行了积极的探索，已取得初步成效。不少地方利用温度、湿度、气敏、光照等多种传感器对蔬菜生长过程进行全程数据化管控，保证蔬菜生长过程绿色环保、有机生产。也有地方通过物联网技术，对农作物生长、畜禽和水产养殖等进行监测，可实现准确感知、及时反馈，提升农业决策指挥水平。有的地方应用物联网技术改造传统农业，可实现对农业用药、用水、用肥、用工状况的精确控制，减少浪费,促进农业节本增效。\n',

                              ],
                              list2:[
                                  '提高农业资源的利用效率。获取环境信息和土壤、气温、水文等极为精细的农业资源信息，配合农业资源调度系统，就能让管理人员实现科学决策。\n',
                                  '降低农业生产成本。在家就可实时监控光照、温室温度情况，自动控制水帘降温、天窗开闭和风机运行等程序，不仅节约人力成本，而且农民朋友无需再到太阳底下暴晒了。',
                                  '提高农业产出，增加农民收入。物联网技术在农业的应用，不仅带动了国民经济的增长，促进了我国农业产业化的进步，而且还推动了传统农业迅速向现代农业的转变，提高了农民生活水平。\n',
                                  '通过农业智能设备快速收集有效信息并进行智能调控，提高了农业生产效率，降低了农业生产成本，促进农民收入的增加，这是农业物联网最主要的作用。\n',
                                  '农业现代化和智能化是我国农业发展的趋势，物联网技术在农业上的应用改变了传统的“靠天吃饭”的生产方式，使有限的农业资源可以产出更多安全和高质量的农产品，对于整个农业的发展以及推动农业智能化进程起着积极的促进作用。\n'
                              ]
                          },
                          {
                              title:'青禾农场智慧化提升综合示范项目',
                              id:'second',
                              image:[qhnc1,qhnc2],
                              icon:unitIcon,
                              list1:[
                                  '青禾智慧农业示范区位于江阴市徐霞客镇阳庄村，占地约550亩。是一个以绿色蔬菜、时令鲜果、无公害水产及特种养殖为主题的现代农业产业基地。2019-2020年江阴公司把握综合能源发展趋势，积极响应公司中国特色的能源互联网企业的战略部署，将青禾农场初步建成了一个集源、网、荷、储、充于一体的新型农业复合绿色微电网。为了响应国乡村振兴战略，全面落实国网公司乡村电气化工作部署，现在决定结合当地农业生产特点，以青禾农场为示范将农场农业管理、农业生产、农业存储、农业加工、农业配送等环节进行电气化改造，并纳入到综合管控中，坚持服务乡村电气化和服务客户侧在电力物联网落地，加快推进农业生产、乡村产业、农村生活电气化和乡村供电智慧服务，努力构建“以电气化促乡村现代化、以物联网促电气化高质量发展”的方式，引领带动公司乡村电气化全面开展。\n'
                              ],
                              list2:[
                                  '（1）更全范围的农业电气化改造。从农作物育苗、农业田间管理、农业生产、农作物采摘、农作物加工、农作物存储、农作物配送全环节改造，改造传统非电设备为电气化设备。\n',
                                  '（2）农业智慧用电：通过农业大棚电气化改造，部署无线采集网络和无线采集设备，实现农业生产全过程全方位的设备用能、农业生产和种植环境的监控，并根据农业生产情况进行智慧用电控制。\n',
                                  '（3）农业能效提升：实现对用户负荷的精细化采集和管理，利用获取的负荷数据，进而开展能效诊断，分析挖掘节能潜力，制定节能用电策略，降低能源使用成本，通过建设农业电气化大棚采集和智能控制设备，实现电、水、化肥、农药等精准使用。\n',
                                  '（4）促进农场用电指标的提升：结合农场现有的配电网络，将现有的光伏、储能等接入进去，对户外的配电设施改造并加强监测，提高分布式能源自发自用率，同时通过协调控制降低农场的配电故障率和停电率，提高农场供电可靠率。\n',
                                  '（5）归纳一套可复制拓展模式：依据农场示范区现状以及发展要求，将电力物联网在农村农场应用与乡村电气化示范相结合，形成符合地方发展、建设方案合理、应用方便快捷、使用安全可靠的可推广可复制模式。\n'
                              ]
                          },{
                              title:'青禾二期农业智慧平台',
                              id:'third',
                              image:[qhnc1,qhnc2],
                              icon:unitIcon,
                              list1:[
                                  '随着国家层面对土地集约化经营程度的不断加深，物联网概念在农业生产管理环节内的不断深入，规模化、科学化、数据化的种植方式已经愈发成为行业趋势。对于传统大规模种植而言，大量人力投入、工作效率低下、过多的资源浪费以及不可避免的人为误差与安全隐患已经成为传统种植模式的显著弊端，已经成为农业发展进程中的绊脚石。\n',
                                  '为了实现能耗的降低，科学的种植，系统化、规模化的精细化管理，建立一个生产与管理的快速信息通道，建立统一化的综合管控平台尤为关键。通过实时掌握植物的生长环境信息，建立种植过程中的大数据库。通过实时采集农业生产过程中的温度、湿度、土壤水分、土壤温度、土壤肥力等基础数据，从而根据不同农作物、不同生长周期内所需各种良好条件制定出科学有效的措施。从而保证在最小资源使用的情况下，对作物所需水分、肥量进行科学的自动化反馈。从而最大限度内提高作物产量，改善农产品的品质，节约不必要的人力，杜绝安全隐患。\n',
                                  '利用科学的方法，精确的数据基础进行精细化管理，不仅为政府监管部门提供可靠准确的数据，方便制定应急措施与方案，同时也可以切实的为农民提供科学、合理的种植办法，增加最终受益。\n'
                              ],
                              list2:[
                                  '1.设备层\n',
                                  '系统设备层主要分为数据收集设备与逻辑控制设备，数据收集设备负责将农业生产过程中的重要数据进行系统化集中。包括农作物生长环境数据、农作物自身数据、生产管理人员数据等。设备主要分为六大类：\n',
                                  '（1）无线数据传感器，主要包括收集空气温湿度、光照度、CO2浓度，水体数据，土壤温度、土壤水分、土壤PH值，土壤肥力等信息采集传感器。\n',
                                  '（2）有线扩展模块，主要包括在广泛分布的农业生产过程中相对集中的密集型数据采集环境，通过有线数据采集扩展模块，实现多种方式的数据传感器的组网，用尽量低的成本采集到足够多的样本数据。\n',
                                  '（3）无线逻辑控制器，实现对农业生产过程中的可控电气设备进行逻辑控制，如卷帘机、卷膜机、方风机、喷淋、滴灌、补光、补CO2、施肥机等。\n',
                                  '（4）物联网摄像头，用于农业生产环节中实时视频监控，与安全防盗监控，便于管理人员在第一时间了解生产环节中的实时情况。\n',
                                  '（5）智能网关，支持NB-Iot、GPRS、3G/4G、wifi、lora、蓝牙、433MHz、RS485等无线与有线连接方式，内部集成多种预设逻辑模式，便于现场组网与数据汇总上传。\n',
                                  '（6）小型智能气象设备，可以高效收集一定范围内的气象数据，为系统运行提供准确的环境数据支撑。\n',
                                  '2.网络层\n',
                                  '设备与网关之间、网关与物联网平台之间的数据交换行程网络传输层。包括传感器有线组网、短距离无线组网、物联网专网与公共网络。平台通过预设配置将多重网络以固有规则进行统一规划、集中管控，实现多重网络下的分散与统一。\n',
                                  '3.平台层\n',
                                  '平台采用B/S经典架构，同时配合专用App，实现跨平台、跨地域的统一管理。底层设备通过TCP/IP、UDP、HTTP等协议接入管理平台，与平台建立加密通讯连接。第三方平台通过API接口实现多平台数据互通。\n',
                                  '数据分析：平台提供大数据存储与分析基础架构，为农业生产环节提供简单高效的基础分析能力。\n',
                                  '设备管理：通过平台设备管理对生产过程中涉及到的硬件设备进行实施管理。\n',
                                  '数据监测：使用B/S结构的软件界面、APP应用等，具有权限的用户，能够通过上网的设备随时随地的了解现场情况。\n',
                                  '远程控制：用户可远程操控现场设备，还可通过采集的现场数据，根据配置条件、逻辑关系实现设备间的自动控制，最终形成一个大型自控集合系统。\n'
                              ]
                          }
                      ]},
                  {title:'环保',list:[
                          {
                              title:'飞灰云智系统',
                              id:'first',
                              image:[YzImg1,YzImg2],
                              icon:HgIcon,
                              list1:[
                                  '飞灰是垃圾焚烧的必然产物,大约占焚烧垃圾量的3~5%。《十二五”全国城镇生活垃圾无害化处理设施建设规划》(国办发[2012] 23号),规划到2015年新增垃圾焚烧设施262座，处理能力达21.9万吨/日。上海将建老港焚烧厂二期及崇明、嘉定、松江等5座郊区垃圾焚烧厂,新增设施能力达8000吨/日以上。按此计算,全国和上海分别产生飞灰6570~10950 吨/天和240~400吨。如何安全有效地处置焚烧飞灰成为急需解决的环境和社会问题。',
                                  '2008年7月, 《生活垃圾填埋场污染控制标准》( GB16889-2008 )开始实施,规定飞灰应经稳定化处理,满足含水率小于30%、二嗯英含量低于3 ug TEQ/Kg按照HJ/T 300方法制备的浸，出液中危害成分浓度低于规定的限值，方可送往生活垃圾卫生填埋场分区填埋。该标为飞灰进入卫生填埋场进行最终处置提供了规范依据,但对飞灰稳定化处理提出了严格的要求。',
                                  '飞灰从产生开始将被进行一系列的操作和数据的上报，为了更加便捷和完整地对飞灰进行操作就需要更加完整和系统的飞灰管理系统。'
                              ],
                              list2:[
                                  '1.日常数据整理\n',
                                  '将生产数据、检测数据、工况数据等数据整理好并将对应数据通过图表显示出来，数据整合后更加方便查看，且历史数据也更便于保存。',
                                  '',
                                  '2.计划执行\n',
                                  '将周计划和供货计划整合在一起，方便管理层制定计划，且计划和实际的页面可以方便的进行比较，直观展示出计划执行情况。\n',
                                  '',
                                  '3.库存流转\n',
                                  '将暂存区域的数据规范化，库存容量、入库量、出库量数据直观展示，方便管理层查看，也便于暂存库管理人员统计和上报。',
                                  '',
                                  '4.报告和提醒的微信推送\n',
                                  '管理层上传报告和提醒时可选择是否使用微信推送，微信通过公众号将报告或通知直接推送到相关人员手机，方便了领导层和员工之间的沟通。\n'
                              ]
                          },{
                              title:'飞灰填埋云智系统',
                              id:'second',
                              image:[TmImg1,TmImg2],
                              icon:HbIcon,
                              list1:[
                                  '生活垃圾焚烧处理后产生飞灰，产生量为垃圾处理量的3-5%左右。飞灰为含水率很低的灰色粉末 ，飞灰成分主要有 SiO2 , NaC1,KCI，CaAl2Si2Og , CaCO3和CaSO4等矿物;含量高达17.9%的溶解盐;还含有能被水浸出的高浓度的Cd,Pb,Cu,Zn,Hg和Cr等多种重金属,对环境pH变化的抵抗能力强。同时焚烧中产生的二嗯英，50%以上也附着在飞灰上。因此我国在《国家危险废物名录》中明确规定:生活垃圾焚烧飞灰属于危险废物, 必须经过一定的处理，降低其危险性以后，才能进入填埋场进行安全填埋或者考虑进一步的利用。且进行焚烧飞灰预处置及运输的单位必须拥有危险废物经营许可证,运输过程中必须执行危险废物转移联单的管理办法。经过预处置后的飞灰，在达到《生活垃圾填埋场污染控制标准》( TB16889-2008 ) 中的进场要求后,方可进入生活垃圾填埋场填埋。\n',

                              ],
                              list2:[
                                  '1.联单管理',
                                  '将联单进行流程处理，将联单的每一步流程都表示出来，方便管理层查看联单的进度，若飞灰出现问题也可快速找到责任人。\n',
                                  '',
                                  '2.处置单位工作表格汇总填写',
                                  '将处置单位人员工作区分开来，每个人更好的知道自己需做的事情，APP上操作更加便捷了现场工作人员的使用。',
                                  '',
                                  '3.检测人员手机端取样检测',
                                  '处置单位检测人员可用此系统APP进行现场取样抽检，抽检完成后可直接上传报告，与只能在电脑上上传检测结果相比手机端上的上传解放了对工作场地的限制。\n',
                                  '',
                                  '4.领导层更加方便观察各个产废或填埋单位的工作情况\n',
                                  '对于领导层此系统可生成统计视图，更加直观的展示各个产废或填埋单位的生产或填埋数据，且可通过视频监控查看现场情况。\n'
                              ]
                          }]},

                  {title:'城管',list:[
                          {
                              title:'户外广告系统',
                              id:'first',
                              image:[GgImg1,GgImg2],
                              icon:CgIcon,
                              list1:[
                                  '目前，我国户外广告行业实行政府监管与行业自律相结合的管理体制。\n',
                                  '广告行业的主管部门]为国家市场监督管理总局以及各级地方市场监督管理局，其整合了原国家工商行政管理总局、国家质量监督检验检疫总局、国家食品药品监督管理总局等相关机构的职责，主要负责广告发布活动和广告经营活动的监督管理工作，同时指导广告行业发展。',
                                  '中国共产党中央委员会宣传部作为中共中央主管意识形态方面工作的综合职能部门,中华人民共和国文化部作为国务院下属负责中国文化、艺术事业的最高行政机构，对广告行业均起到了管理、监督和指导的作用。'
                              ],
                              list2:[
                                  '1.加强宣传引导。召开参加整治相关人员动员会议，明确专项整治工作的目的、意义、范围、标准及要求;执法人员要深入沿街店面、单位广泛宣传法律、法规及相关政策，扩大影响，营造积极支持、主动参与的良好氛围。',
                                  '',
                                  '2.依法实施界定。对照户外广告规划和容貌标准，对调查情况进行全面核实、界定，确定整治任务。\n',
                                  '',
                                  '3.完备执法手续。对确定整治的户外广告进行登记拍照、建档立案，及时告知相关单位和个人，并会同有关单位、街道(社区)共同下发法律文书。\n',
                              ]
                          }
                      ]},
                  {title:'校园',list:[
                          {
                              title:'南京市同仁小学官网',
                              id:'first',
                              image:[PageShow],
                              icon:PageInfo,
                              list1:[
                                  '南京市同仁小学是2004年由鱼市街小学和中山路小学合并而成。学校占地面积6641.5㎡。设施完善，规划科学，配备合理，建有近千平方米的室内体育馆和国家级“观花项目”平台。',
                                  '学校是南京市小班化教育示范学校。现有在校生523人，在职教师45人，其中高级教师2人，一级教师31人，二级教师9人。大专以上学历达100%，市区骨干教师比例达35.6%。',
                                  '学校秉承“同心立仁”的教育理念，确立“凝聚众人的智慧，培养具有恭、宽、信、敏、惠品德的小公民，建设有质量、有品质、有底蕴的小班化精品学校”的办学目标，求实进取，开拓创新。'
                              ],
                              list2:[
                                  ' 南京市同仁小学是2004年由鱼市街小学和中山路小学合并而成。学校占地面积6641.5㎡。设施完善，规划科学，配备合理，建有近千平方米的室内体育馆和国家级“观花项目”平台。',
                                  '学校是南京市小班化教育示范学校。现有在校生523人，在职教师45人，其中高级教师2人，一级教师31人，二级教师9人。大专以上学历达100%，市区骨干教师比例达35.6%。',
                                  '学校秉承“同心立仁”的教育理念，确立“凝聚众人的智慧，培养具有恭、宽、信、敏、惠品德的小公民，建设有质量、有品质、有底蕴的小班化精品学校”的办学目标，求实进取，开拓创新。',
                                  '学校秉承“同心立仁”的教育理念，确立“凝聚众人的智慧，培养具有恭、宽、信、敏、惠品德的小公民，建设有质量、有品质、有底蕴的小班化精品学校”的办学目标，求实进取，开拓创新。',
                                  ' 仁爱文化浸润的同仁小学致力于HUI学课堂的研究！慧学——理解每一个，自我认识，探索主动学习的有效性；汇学——支持每一个，优质组元，挖掘深度学习的着力点；惠学——发展每一个，教学相长，营造互动学习的合作场；会学——成就每一个，触类旁通，提升自主学习的学习力！HUI学课堂，让学生学会学习，让学习真正发生！',
                                  '学校立足“仁”的境界，近年来，推出“面向每一个”的《小班化教师十项承诺》，打造阳光体育舞蹈特色品牌课程，开设缤纷师本课程。深度研究市级规划课题《优质组元：小班背景下促进学生深度学习的行动研究》和党建市级规划课题《Happy十分钟》，着力构建高品质的小班化教育新样态。',
                                  '学校先后获得江苏省实验小学、南京市首批小班化示范学校、南京市模范教工之家、南京市无烟学校、南京市阳光体育学校、江苏省“十一五”规划重点课题科学认读实验基地、南京市依法治校示范校、金陵书香校园、玄武区文明单位、江苏省第二届教学研究成果（《组元教学：小班化课堂教学的变革》）一等奖等诸多荣誉。',
                                  '“时代是出卷人，我们是答卷人，人民是阅卷人。”这是习近平总书记说的一句耳目一新、意味深长的话。不忘初心、牢记使命。学生好，教师好，家长好，学校才会好！同仁小学要努力做大家满意的答卷人！'
                              ]
                          }, {
                              title:'学习者课堂评价系统',
                              id:'second',
                              image:[XxImg1,XxImg2],
                              icon:ClassIcon,
                              list1:[
                                  '课程评价是教育课程建设的重要手段,是教育质量提升的重要途径.目前我国教育课程种类繁多,但有关课程评价的理论与实践研究却十分滞后,无法对各种课程的质量和实施效果进行系统评估,严重制约了我国课程建设的质量。',
                                  '美国教育科学院于2002年启动的"教育课程评价研究"项目对发展我国教育课程评价具有重要的启发与借鉴价值.为此,组建了专门的课程实施团队,实践了14种较具代表性的教育课程方案,而后由独立的课程评价团队对其效果进行评价.他们广泛采用了儿童评价,教师报告,课堂观察,教师访谈与问卷调查,家长访谈等量化与质性评价方法,所得结论虽然不容乐观,亦受到多方质疑,认为该项目在评价目标,所选样本,考虑影响因素,深入分析数据程度等方面存在诸多局限,但其历时七年的研究还是有许多值得我们学习的地方.我们应提高对教育课程评价作用与意义的认识,并在此观念指导下,努力建构符合我国实际的科学而专业的教育课程评价体系。'
                              ],
                              list2:[
                                  '对课程实施的评价:  ',
                                  '1.上级相关部门的检查、督导督查;',
                                  '2.学校课程管理核心部门周期性评估;',
                                  '3.教师自查诊断，及时调整和改进。',
                                  '',
                                  '对教师的评价:  ',
                                  '1.重视教育行为、态度和工作质量;',
                                  '2.重视教师对学习小组的管理和评价，让老师更好的观察到学生的合作意识和能力。',
                                  '',
                                  '对学生的评价:  ',
                                  '1.进一步完善学校对综合学科的调研制度，关注对学生的全面评价。',
                                  '2.继续规范记录学生的学习成长，并通过图表让家长直观查看到。',
                                  '',
                                  '评价方式: ',
                                  '1.任课老师评价: 任课老师要对学生所在小组从合作质量、合作效率、合作氛围三方面来进行评价，组长评价完成后任课老师和家长可以查看相应的学生上课评分情况。',
                                  ' 2.小组组长评价: 小组组长要对本组组员通过倾听、表达、对话三方面进行评价，评价完成后任课老师和家长可以查看相应的学生上课评分情况。'
                              ]
                          },
                      ]},
              ],
          }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            },
            '$route'(newVal){
                if(this.$route.path === newVal.path){
                    this.$router.go(0)
                }
                console.log(newVal)
            }
        },
        created() {
            this.pageKey = this.$route.query.id;
            this.pageIndex = this.$route.query.index;
            this.listIndex = this.pageInfoList[this.pageIndex].list.findIndex(item =>{
                return item.id === this.pageKey
            })
            console.log(this.pageKey,this.pageIndex)
        },
        mounted() {
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;
            // console.log(this.channelWidth);
            window.addEventListener('scroll',this.handleScroll)
        }
    }
</script>

<style lang="scss" src="./cases-page.scss" scoped>

</style>
